import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'
import { SessionManager, showAccessDeniedAlert, showTokenExpiredAlert, getConfig } from 'utils'

export const inOutCount = createAsyncThunk('inOutCount/count', async ({ navigate }) => {
    try {
        const res = await axios({
            method: 'GET',
            url: getConfig.API_URL + 'inout_log',
            params: {
                pageSize: 100,
                pageNo: 0,
                status: 'In',
                user_type: 'S,ST,D,V,PV',
                count: true,
            },
            headers: {
                'Content-Type': 'application/json',
                Authorization: SessionManager.getCookie('user_token'),
            },
        })
        return res
    } catch (error) {
        return error.response
    }
})

const inOutCountSlice = createSlice({
    name: 'inOutCount',
    initialState: {
        currently_inside: 0,
        overstaying: 0,
        entered_today: 0,
        loading: false,
    },
    extraReducers: (builder) => {
        builder.addCase(inOutCount.pending, (state) => {
            state.loading = true
        })
        builder.addCase(inOutCount.fulfilled, (state, action) => {
            state.loading = false
            if (action?.payload?.status === 200) {
                const counts = action.payload.data?.in_out_count || {}
                state.currently_inside = counts.currently_inside ?? 0
                state.overstaying = counts.overstaying ?? 0
                state.entered_today = counts.entered_today ?? 0
            } else if (action?.payload?.status === 401) {
                showTokenExpiredAlert(action?.payload?.data?.message, action.meta.arg.navigate)
            } else if (action?.payload?.status === 403) {
                showAccessDeniedAlert(action.meta.arg.navigate)
            } else {
                state.currently_inside = 0
                state.overstaying = 0
                state.entered_today = 0
            }
        })
        builder.addCase(inOutCount.rejected, (state) => {
            state.loading = false
        })
    },
})

export default inOutCountSlice.reducer
